import { withInRange } from '../../common/utils/helper';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { ColumnBase } from './column-base';
/**
 * The `BarSeries` module is used to render the bar series.
 */
export class BarSeries extends ColumnBase {
    constructor() {
        super(...arguments);
        this.sideBySideInfo = [];
    }
    /**
     * Render Bar series.
     *
     * @param {Series} series - Defines the series.
     * @returns {void}
     * @private
     */
    render(series) {
        const origin = Math.max(series.yAxis.visibleRange.min, 0);
        this.sideBySideInfo[series.index] = this.getSideBySideInfo(series);
        for (const pointBar of series.points) {
            this.renderPoint(series, pointBar, this.sideBySideInfo[series.index], origin);
        }
        this.renderMarker(series);
    }
    renderPoint(series, pointBar, sideBySideInfo, origin) {
        pointBar.symbolLocations = [];
        pointBar.regions = [];
        if (pointBar.visible && withInRange(series.points[pointBar.index - 1], pointBar, series.points[pointBar.index + 1], series)) {
            this.rect = this.getRectangle(pointBar.xValue + sideBySideInfo.start, pointBar.yValue, pointBar.xValue + sideBySideInfo.end, origin, series);
            if (series.columnWidthInPixel) {
                const widthInPixel = series.columnWidthInPixel;
                const halfWidth = widthInPixel ? (widthInPixel / 2) : 0;
                const rectCount = isNullOrUndefined(series.rectCount) ? 0 : series.rectCount;
                const position = isNullOrUndefined(series.position) ? 0 : series.position;
                const sideBySideEnabled = series.chart.enableSideBySidePlacement ? 0 : halfWidth;
                this.rect.height = widthInPixel;
                this.rect.y = this.rect.y - ((halfWidth * rectCount) - (widthInPixel * (rectCount - position - 1))) + (sideBySideEnabled);
            }
            const argsData = this.triggerEvent(series, pointBar, series.interior, { width: series.border.width, color: series.border.color });
            if (!argsData.cancel) {
                this.updateSymbolLocation(pointBar, this.rect, series);
                this.drawRectangle(series, pointBar, this.rect, argsData);
                if (series.columnFacet === 'Cylinder') {
                    const cylinderSeriesOption = {
                        'isColumn': false,
                        'stacking': false,
                        'isLastSeries': true
                    };
                    this.drawCylinder(this.options, this.element, cylinderSeriesOption, this.rect, series);
                }
            }
        }
    }
    updateDirection(series, point) {
        const origin = Math.max(series.yAxis.visibleRange.min, 0);
        for (let i = 0; i < point.length; i++) {
            this.renderPoint(series, series.points[point[i]], this.sideBySideInfo[series.index], origin);
            if (series.marker && series.marker.visible) {
                series.chart.markerRender.renderMarker(series, series.points[point[i]], series.points[point[i]].symbolLocations[0], null, true);
            }
            if (series.marker.dataLabel.visible && series.chart.dataLabelModule) {
                series.chart.dataLabelModule.commonId = series.chart.element.id + '_Series_' + series.index + '_Point_';
                series.chart.dataLabelModule.renderDataLabel(series, series.points[point[i]], null, series.marker.dataLabel);
            }
        }
    }
    /**
     * Animates the series.
     *
     * @param  {Series} series - Defines the series to animate.
     * @returns {void}
     * @private
     */
    doAnimation(series) {
        this.animate(series);
    }
    /**
     * To destroy the bar series.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroy method performed here.
         */
    }
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */
    getModuleName() {
        return 'BarSeries';
    }
}
